import { graphqlApolloClient } from "../graphql-apollo-client"
import { CREATE_PROJECT_MONTH_STATUS_QUERY } from "./gql/create-project-month-status"
import { GET_PROJECT_MONTH_STATUS } from "./gql/get-project_month-status"
import { UPDATE_PROJECT_MONTH_STATUS_QUERY } from "./gql/update-project-month-status"
import { MONTHS_NAMES_ARRAY } from "../../helpers"
import { CREATE_PROJECT_MONTHS_STATUS_ROWS } from "./gql/create-project-month-status-rows"
import { GET_MONTH_EDITABLE_STATUS } from "./gql/get-month-editable-status"
import {SET_EMAIL_PROJECT_MONTH_STATUS_QUERY} from "./gql/set-email-project-month-status"

export const monthStatusService = () => {
  const updateMonthStatusByProject = async ({ submissionId, data }) => {
    const { data: monthsPeriodsData } = await graphqlApolloClient.mutate({
      mutation: CREATE_PROJECT_MONTH_STATUS_QUERY,
      variables: {
        submissionId,
        data
      }
    })
    return monthsPeriodsData?.CreateProjectMonthStatusData
  }

  const createProjectMonthsStatusRows = async ({ submissionId }) => {
    const { data: monthsPeriodsData } = await graphqlApolloClient.mutate({
      mutation: CREATE_PROJECT_MONTHS_STATUS_ROWS,
      variables: {
        submissionId
      }
    })
    return monthsPeriodsData?.CreateProjectMonthStatusRows
  }

  const updateMonthStatus = async ({ id, data }) => {
    const { data: monthsPeriodsData } = await graphqlApolloClient.mutate({
      mutation: UPDATE_PROJECT_MONTH_STATUS_QUERY,
      variables: {
        id,
        data
      }
    })
    return monthsPeriodsData?.UpdateProjectMonthStatusData
  }

  const setEmailMonthStatus = async ({ email, typeMonitoring, month, proyect }) => {
    const response = await graphqlApolloClient.mutate({
      mutation: SET_EMAIL_PROJECT_MONTH_STATUS_QUERY,
      variables: {
        email, 
        typeMonitoring, 
        month, 
        proyect
      }
    })
    return response
  }

  const getProjectMonthStatus = async ({ submissionId }) => {
    const { data } = await graphqlApolloClient.query({
      query: GET_PROJECT_MONTH_STATUS,
      fetchPolicy: "network-only",
      variables: { submissionId }
    })
    return data?.getProjectMonthStatusBySubmission?.toSorted((a, b) => {
      if (a.year === b.year) return MONTHS_NAMES_ARRAY.indexOf(a.month) - MONTHS_NAMES_ARRAY.indexOf(b.month)
      return a.year - b.year
    })
  }

  const getMonthEditableStatusBySubmission = async ({ submissionId }) => {
    const { data } = await graphqlApolloClient.query({
      query: GET_MONTH_EDITABLE_STATUS,
      fetchPolicy: "network-only",
      variables: { submissionId }
    })
    return data?.getMonthEditableStatusBySubmission
  }

  return {
    updateMonthStatus,
    updateMonthStatusByProject,
    createProjectMonthsStatusRows,
    getMonthEditableStatusBySubmission,
    getProjectMonthStatus,
    setEmailMonthStatus
  }
}
